import vosClient, { IVosResponse } from "../../vosClient";

export interface SeatClassItem {
  Code: string;
  Name_VN: string;
}

export class SeatClassService {
  static async getSeatClassList() {
    const response = await vosClient.get<IVosResponse<SeatClassItem[]>>("/api/department/code-ticket-class");

    return response.data;
  }
}
